import React, { Component } from 'react'
import columns from './columns'
import { SearchBarTable, Flex } from 'hljd'
import Store from './store'
import SearchBar from '../SearchBar'
import style from './style.module.less'
import { observer } from 'mobx-react'
import { Button } from 'hljd'

const MoneyBox = ({ title, money, moneyStyle, unit, noBorder }) => {
  return (
    <Flex
      d="v"
      hc
      style={{
        minWidth: 130,
        paddingRight: 20,
        marginRight: 20,
        ...(!noBorder && { borderRight: '1px solid #f2f2f3' })
      }}
    >
      <div style={{ color: '#a6a5aa', marginBottom: 5 }}>{title}</div>
      <div>
        <span style={{ fontSize: 24, marginRight: 5, ...moneyStyle }}>
          {unit} {money}
        </span>
        <span>元</span>
      </div>
    </Flex>
  )
}

@observer
export default class extends Component {
  constructor(props) {
    super(props)

    this.store = new Store()
  }

  render() {
    const { listData, exportList } = this.store
    const { entryMoneySum, outMoneySum } = listData
    return (
      <>
        <SearchBar
          store={this.store}
          timeKey="trade_time"
          extra={<Button onClick={exportList}>导出流水明细</Button>}
        />

        <div className={style.money}>
          <Flex style={{ height: '100%', padding: 20 }}>
            <MoneyBox
              title="累计入账"
              money={entryMoneySum}
              unit="+"
              moneyStyle={{ color: '#47D788' }}
            />
            <MoneyBox
              title="累计出账"
              money={outMoneySum}
              unit="-"
              moneyStyle={{ color: '#FF801A' }}
              noBorder={true}
            />
          </Flex>
        </div>

        <SearchBarTable columns={columns} store={this.store} />
      </>
    )
  }
}
